import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import TWITTER_ICON from "../../../assets/images/twitter_icon.svg";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { BASE_URL } from "../../../constant/apiURL";
import { openInNewTab } from "../../../helpers/Common";

const PROFILE_PLACEHOLDER = require("../../../assets/images/user_placeholder.png");

const fir = 0.0;
const gir = 0.0;
const ppr = 0.0;

const useStyles = makeStyles((theme) => ({
  playerprofilebtn: {
    backgroundColor: "#06623B !important",
    color: "#FFF !important",
    borderRadius: "5px !important",
    fontWeight: "400 !important",
    minWidth: "175px !important",
    padding: "10px 20px !important",
    textTransform: "capitalize !important",
  },
  profileHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center !important",
    position: "relative",
  },
  profileCard: {
    paddingTop: "30px",
    position: "relative",
    zIndex: 1,
    "&::before": {
      content: '""',
      width: "100%",
      height: "150px",
      backgroundColor: "#06623B",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: -1,
    },
  },
  profileImg: {
    width: "140px",
    height: "140px",
    border: "4px solid #FFF",
    objectFit: "cover",
    borderRadius: "50%",
    ["@media (max-width: 300px)"]: {
      width: "90px",
      height: "90px",
    },
  },
  profileHeaderText: {
    color: "#fff",
    textAlign: "center",
  },
  socialBtn: {
    cursor: "pointer",
    backgroundColor: "#000000",
    width: 30,
    height: 30,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  profileStatText: {
    backgroundColor: "#06623B",
    color: "#fff",
    width: "100%",
    textAlign: "center",
    margin: "20px 0 !important",
    padding: "10px",
  },
  scoreIcon: {
    width: 30,
    height: 30,
    marginRight: 15,
  },
  divider: {
    width: "2% !important",
    height: "100% !important",
  },
  progressLabel: {
    whiteSpace: "nowrap",
    fontWeight: "500",
    textDecoration: "underline",
    textAlign: "center",
    marginBottom: "100px",
  },
}));

export default function ProfileInfo({ playerData , average}) {
  const classes = useStyles();

  const player_wins = playerData?.wins || 0;
  const player_losses = playerData?.losses || 0;
  const total_matches = playerData?.total || 0;
  var social_facebook, social_twitter, social_instagram, social_linkedin;

  if (playerData?.social_links.length > 0) {
    social_facebook = playerData?.social_links?.filter(
      (sl) => sl.name.toLowerCase() === "facebook"
    );
    social_twitter = playerData?.social_links?.filter(
      (sl) => sl.name.toLowerCase() === "twitter"
    );
    social_instagram = playerData?.social_links?.filter(
      (sl) => sl.name.toLowerCase() === "instagram"
    );
    social_linkedin = playerData?.social_links?.filter(
      (sl) => sl.name.toLowerCase() === "linkedin"
    );

    if (social_facebook.length > 0) social_facebook = social_facebook[0];
    if (social_twitter.length > 0) social_twitter = social_twitter[0];
    if (social_instagram.length > 0) social_instagram = social_instagram[0];
    if (social_linkedin.length > 0) social_linkedin = social_linkedin[0];
  }

  var win_percent = (player_wins / total_matches) * 100;
  if (isNaN(win_percent)) win_percent = 0;

  var avg_score = (player_wins / (player_wins + player_losses)) * 100;
  if (isNaN(avg_score)) avg_score = 0;

  const _handleSocialOnClick = (e, link) => {
    let url = "";
    if (link !== "") {
      if (
        (!link.startsWith("https://") || !link.startsWith("http://")) &&
        link.includes("www")
      ) {
        url = `https://${link}`;
      } else if (
        (!link.startsWith("https://") || !link.startsWith("http://")) &&
        !link.includes("www")
      ) {
        url = `https://www.${link}`;
      } else {
        url = link;
      }
      window.open(url, "_blank");
    }
  };

  return (
    <Box className={classes.profileHeader}>
      <Box className={classes.profileCard}>
        <Typography variant="h6" className={classes.profileHeaderText}>
          Player Profile
        </Typography>
        <Box sx={{ textAlign: "center", marginTop: "30px" }}>
          <img
            src={
              playerData !== undefined && playerData?.image
                ? `${BASE_URL}${playerData.image}`
                : PROFILE_PLACEHOLDER
            }
            className={classes.profileImg}
            alt={playerData !== undefined && playerData?.first_name}
          />
        </Box>
        <Box sx={{ textAlign: "center", marginTop: "10px" }}>
          <Typography sx={{ fontWeight: 500 }} color={"#000000"} variant="h5">
            {playerData !== undefined && (
              <>
                {playerData?.first_name} {playerData?.last_name}
              </>
            )}
          </Typography>
          <Typography
            color={"#000000"}
            variant="subtitle1"
            sx={{ wordWrap: "break-word" }}
            marginBottom={1}
          >
            {playerData !== undefined && playerData?.email}
          </Typography>
        </Box>

        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item mx={1} className={classes.socialBtn}>
            <FacebookOutlinedIcon
              style={{ color: "white" }}
              fontSize="medium"
              onClick={(e) => _handleSocialOnClick(e, social_facebook.link)}
            />
          </Grid>
          <Grid
            item
            mx={1}
            className={classes.socialBtn}
            onClick={(e) => _handleSocialOnClick(e, social_twitter.link)}
          >
            <img src={TWITTER_ICON} alt="twitter" />
          </Grid>
          <Grid
            item
            mx={1}
            className={classes.socialBtn}
            onClick={(e) => _handleSocialOnClick(e, social_instagram.link)}
          >
            <InstagramIcon htmlColor="white" fontSize="small" />
          </Grid>
          <Grid
            item
            mx={1}
            className={classes.socialBtn}
            onClick={(e) => _handleSocialOnClick(e, social_linkedin.link)}
          >
            <LinkedInIcon htmlColor="white" fontSize="small" />
          </Grid>
        </Grid>
      </Box>

      <Typography variant="subtitle2" className={classes.profileStatText}>
        Player Stats
      </Typography>

      <Grid
        container
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid
          item
          xs={6}
          md={3}
          p={1}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="caption" className={classes.progressLabel}>
            WHS Index
          </Typography>
          <div style={{ width: 50 }}>
            <CircularProgressbar
              value={parseFloat(playerData?.handicap).toFixed(1)}
              maxValue={15}
              text={`${parseFloat(playerData?.handicap).toFixed(1)}`}
              strokeWidth="10"
              styles={buildStyles({
                pathColor: "#06623B",
                textColor: "#000000",
              })}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          p={1}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="caption" className={classes.progressLabel}>
            POTY Rank
          </Typography>
          <div style={{ width: 50 }}>
            <CircularProgressbar
              value={playerData?.poty_rank}
              text={`${playerData?.poty_rank || 0}`}
              maxValue={140}
              strokeWidth="10"
              styles={buildStyles({
                pathColor: "#000000",
                textColor: "#000000",
              })}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          p={1}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="caption" className={classes.progressLabel}>
            Avg. Score
          </Typography>
          <div style={{ width: 50 }}>
            <CircularProgressbar
              value={average}
              maxValue={100}
              text={`${average}`}
              strokeWidth="10"
              styles={buildStyles({
                pathColor: "#EE920F",
                textColor: "#000000",
              })}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          p={1}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="caption" className={classes.progressLabel}>
            Win %
          </Typography>
          <div style={{ width: 50 }}>
            <CircularProgressbar
              value={playerData?.win_per}
              text={`${playerData?.win_per || 0}`}
              maxValue={100}
              strokeWidth="10"
              styles={buildStyles({
                pathColor: "#FF0000",
                textColor: "#000000",
              })}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          p={1}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="caption" className={classes.progressLabel}>
            FIR
          </Typography>
          <div style={{ width: 50 }}>
            <CircularProgressbar
              value={playerData?.fir?.$numberDecimal}
              maxValue={100}
              text={`${playerData?.fir?.$numberDecimal || 0}`}
              strokeWidth="10"
              styles={buildStyles({
                pathColor: "#0C2DD8",
                textColor: "#000000",
              })}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          p={1}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="caption" className={classes.progressLabel}>
            GIR
          </Typography>
          <div style={{ width: 50 }}>
            <CircularProgressbar
              value={playerData?.gir?.$numberDecimal}
              maxValue={100}
              text={`${playerData?.gir?.$numberDecimal || 0}`}
              strokeWidth="10"
              styles={buildStyles({
                pathColor: "#EE920F",
                textColor: "#000000",
              })}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          p={1}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="caption" className={classes.progressLabel}>
            PPR
          </Typography>
          <div style={{ width: 50 }}>
            <CircularProgressbar
              value={playerData?.putts}
              maxValue={100}
              text={`${playerData?.putts || 0}`}
              strokeWidth="10"
              styles={buildStyles({
                pathColor: "#FF0000",
                textColor: "#000000",
              })}
            />
          </div>
        </Grid>
      </Grid>
    </Box>
  );
}
